import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <div style={{
      minHeight: '95vh',
      background: 'linear-gradient(45deg,rgb(255, 255, 255),rgb(255, 255, 255))',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      color: '#333',
      padding: '20px',
      textAlign: 'center'
    }}>
      <h1 style={{
        fontSize: '4rem',
        marginBottom: '0.5em',
        textShadow: '2px 2px 4px rgba(0,0,0,0.2)'
      }}>
        404
      </h1>
      <h2 style={{
        fontSize: '2rem',
        marginBottom: '1em'
      }}>
        ¡Ups! Página no encontrada.
      </h2>
      <p style={{
        fontSize: '1.2rem',
        maxWidth: '400px'
      }}>
        La ruta a la que intentas acceder no existe. ¡Pero no te preocupes, vuelve a intentarlo con una sonrisa!
      </p>
      <button 
        onClick={() => navigate('/')} 
        style={{
          marginTop: '20px',
          padding: '10px 20px',
          fontSize: '1rem',
          backgroundColor: '#3555dd',
          color: '#fff',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer'
        }}
      >
        Ir al inicio
      </button>
    </div>
  );
};

export default NotFound;
